module.exports = __webpack_public_path__ + "img/welcome_home.f305b69d.png";